
export const FETCH_ALL = "FETCH_ALL"
export const ADD_NEW = "ADD_NEW"
export const UPDATE = "UPDATE"
export const DELETE = "DELETE"

export const ALL_ANSWERS = "ALL_ANSWERS"
export const NEW_ANSWER = "NEW_ANSWER"

export const AUTH = "AUTH"
export const LOGOUT = "LOGOUT"
export const ALL_USERS = "ALL_USERS"